/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TableView = {
  readonly id?: number;
  name: string;
  visibility?: TableView.visibility;
  table_definition?: any;
  readonly view_type?: TableView.view_type;
  is_default?: boolean;
  readonly created_by?: number | null;
  readonly created_at?: string;
  readonly updated_at?: string;
};
export namespace TableView {
  export enum visibility {
    PRIVATE = 'private',
    PUBLIC = 'public',
  }
  export enum view_type {
    MODELS = 'models',
    VALUATIONS = 'valuations',
  }
}
